// Hero.tsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-[#FAF7F2] overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute w-96 h-96 desktop:top-[-100px] desktop:right-[-100px] laptop:top-[-100px] laptop:right-[-100px] tablet:top-[-50px] tablet:right-[-50px] mobile:top-[-30px] mobile:right-[-30px] rounded-full border border-[#C4A484]" />
        <div className="absolute w-72 h-72 desktop:bottom-[-50px] desktop:left-[-50px] laptop:bottom-[-50px] laptop:left-[-50px] tablet:bottom-[-30px] tablet:left-[-30px] mobile:bottom-[-20px] mobile:left-[-20px] rounded-full border border-[#C4A484]" />
      </div>

      <div className="container mx-auto px-6 py-12">
        <div className="flex desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col items-center justify-between min-h-[80vh]">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="desktop:w-1/2 laptop:w-1/2 tablet:w-full mobile:w-full desktop:pr-12 laptop:pr-12 tablet:pr-0 mobile:pr-0"
          >
            <h1 className="desktop:text-6xl laptop:text-5xl tablet:text-4xl mobile:text-3xl font-light text-[#3C3C3C] mb-6">
              Votre beauté,
              <br />
              <span className="font-medium">Notre passion</span>
            </h1>
            <p className="desktop:text-xl laptop:text-lg tablet:text-base mobile:text-sm text-[#666666] mb-8">
              Découvrez l'excellence de la coiffure dans une ambiance élégante
              et raffinée. Notre équipe de professionnels est là pour sublimer
              votre style.
            </p>
            <div className="flex desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col gap-4">
              <Link to="/rendez-vous">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-[#C4A484] text-white px-8 py-3 rounded-full hover:bg-[#B39476] transition-colors duration-300"
                >
                  Prendre rendez-vous
                </motion.button>
              </Link>
              <Link to="/services">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="border border-[#C4A484] text-[#C4A484] px-8 py-3 rounded-full hover:bg-[#FAF7F2] transition-colors duration-300"
                >
                  Nos services
                </motion.button>
              </Link>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="desktop:w-1/2 laptop:w-1/2 tablet:w-full mobile:w-full desktop:mt-0 laptop:mt-0 tablet:mt-12 mobile:mt-8"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-[#C4A484] opacity-10 rounded-2xl transform rotate-3" />
              <img
                src="https://placehold.co/600x800/F5EBE0/C4A484?text=Salon+Interior"
                alt="Salon de coiffure intérieur"
                className="rounded-2xl w-full h-auto object-cover relative z-10"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-4"
      >
        <div className="w-2 h-2 rounded-full bg-[#C4A484] opacity-50" />
        <div className="w-2 h-2 rounded-full bg-[#C4A484]" />
        <div className="w-2 h-2 rounded-full bg-[#C4A484] opacity-50" />
      </motion.div>
    </section>
  );
};

export default Hero;
